// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e51f59c3","11":"6c468c49","58":"0f03c709","126":"ef9c88dd","158":"bab001af","213":"bd2d2247","313":"4c07e4d6","337":"095cfb65","453":"745e6c84","474":"c371db74","667":"3ec56c12","694":"f6f64111","821":"421fb6a0","935":"66bb6055"}[chunkId] + ".chunk.js";
};